<template>
  <div class="modal modal-blur fade" id="post-tags-remove" tabindex="-1" role="dialog" v-show="isShow()" ref="createModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Удаление тега</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            Выберите тег, на который будет переадресация на сайте, после удаление текущего тега
            <div class="mt-1">
              <Multiselect
                  @change="onChange"
                  v-model="fields.tag_id"
                  mode="single"
                  placeholder="Выберите тег"
                  noResultsText="Результатов не найдено"
                  :searchable="true"
                  :close-on-select="true"
                  :options="fields.tags"
                  :trackBy="'title'"
                  :max="1"
              >
                <template v-slot:singlelabel="{ value }">
                  <div class="multiselect-single-label option-item">
                    <div class="item-name"> {{ value.title }}</div>
                  </div>
                </template>
                <template v-slot:option="{ option }">
                  <div class="option-item">
                    <div class="item-name"> {{ option.title }}</div>
                  </div>
                </template>
              </Multiselect>
            </div>
          </div>
          <button class="btn btn-red w-100 mb-3" :class="{'disabled': isDisabledDelBtn()}" @click="onDelete">
            <span class="spinner-border spinner-border-sm me-2" v-show="isProcessDel()"></span>
            Удалить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref, watch} from "vue"
import Multiselect from "@/plugins/multiselect"
import Api from "./services/Api"
import Helper from "@/services/Helper"
import Notify from "@/services/Notify"

let readyPage = ref(false)
let deleting = ref(false)
const fields = reactive(getFields())
const props = defineProps({
  payload: {
    type: Object,
    required: true,
  },
})
const emit = defineEmits(['onDeleted'])
const createModal = ref(null)
let bootModal = null

onMounted(() => {
  clearFields()
  initBootModal()
  readyPageOn()
})

watch(
    () => props.payload?.tag_id,
    async (tagId) => {
      clearFields()

      if (!tagId) return

      fields.tag_id_redirect = tagId

      await fetchTags()
    },
    { immediate: true }
)

function initBootModal() {
  bootModal = new bootstrap.Modal(createModal.value)
}

function closeModal() {
  bootModal.hide()
}

async function fetchTags() {
  let tags = await Api.tags()

  fields.tags = tags.reduce((acc, item) => {
    if (item?.id === fields?.tag_id_redirect) {
      return acc
    }

    acc.push({
      value: item?.id ?? null,
      title: item?.title ?? "",
    });

    return acc;
  }, []);
}

function clearFields() {
  let items = getFields()

  for (let key of Object.keys(items)) {
    fields[key] = items[key]
  }
}

function isReadyPage() {
  return readyPage.value === true
}

function readyPageOn() {
  readyPage.value = true
}

function getFields() {
  return {
    tag_id: null,
    tag_id_redirect: null,
    tags: [],
  }
}

function isDisabledDelBtn() {
  return isProcessDel()
}

function isProcessDel() {
  return deleting.value === true
}

function onChange(value) {
  fields.tag_id = value
}

function isShow() {
  return isReadyPage()
}

function startDeleting() {
  deleting.value = true
}

function stopDeleting() {
  deleting.value = false
}

async function onDelete() {
  if (!Helper.isInt(fields.tag_id)) {
    Notify.error("Выберите тег")
    return
  }

  try {
    startDeleting()
    await Api.delete(fields.tag_id, fields.tag_id_redirect)
    stopDeleting()
    closeModal()
    Notify.success("Тег удален")
    emit("onDeleted", true)
  } catch {
    stopDeleting()
    Notify.error("Ошибка при удалении тега")
    emit("onDeleted", false)
  }
}
</script>

<style scoped>

</style>
